import React, { Fragment, useRef } from 'react'
import RichText from '/src/utils/RichText'
import FluidImage from '/src/utils/FluidImage'
import Heading from '../Heading'
import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'

const WithLargeImagesPopup = (props) => {
    const closeRef = useRef(null)

    return (
        <Transition.Root show={props.open} as={Fragment}>
            <Dialog
                as="div"
                static
                className="fixed z-50 inset-0 overflow-y-auto"
                initialFocus={closeRef}
                open={props.open}
                onClose={() => props.handleSetOpen(false)}
            >
                <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center md:block md:p-0">
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-60 transition-opacity" />
                </Transition.Child>

                {/* This element is to trick the browser into centering the modal contents. */}
                <span className="hidden md:inline-block md:align-middle md:h-screen" aria-hidden="true">
                    &#8203;
                </span>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
                    enterTo="opacity-100 translate-y-0 md:scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 translate-y-0 md:scale-100"
                    leaveTo="opacity-0 translate-y-4 md:translate-y-0 md:scale-95"
                >
                    <div className="inline-block align-bottom bg-white rounded p-8 text-left overflow-hidden shadow-xl transform transition-all md:my-8 md:mx-4 md:align-middle md:max-w-6xl md:p-12">
                        <div className="block absolute top-0 right-0 pt-4 pr-4">
                        <button
                            type="button"
                            className="bg-white rounded text-gray-500 hover:text-darkgrey focus:outline-none"
                            onClick={() => props.handleSetOpen(false)}
                            initialFocus={closeRef}
                        >
                            <span className="sr-only">Close</span>
                            <XIcon className="h-7 w-7" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="flex md:flex-nowrap flex-wrap justify-center items-center md:gap-12 gap-8 md:pt-0 pt-8">
                        <div className="w-full md:w-6/12 lg:p-8">
                            <FluidImage className="block object-cover" image={props.content.image}/>
                        </div>
                        <div className="w-full md:w-6/12">
                            <Heading size="h4" className="text-red mb-0 !leading-none">{props.name}</Heading>
                            <p className="text-darkgrey text-sm font-body">{props.content.position}</p>
                            <div className="text-xs font-body prose max-w-full my-4">
                                <RichText>{props.content.bio}</RichText>
                            </div>
                            <ul className="flex space-x-4">
                                {props.content.twitter &&
                                    <li>
                                        <a href={props.content.twitter} target="_blank" rel="noreferrer" className="text-darkgrey hover:text-red duration-300">
                                            <span className="sr-only">Twitter</span>
                                            <svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                                <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                                            </svg>
                                        </a>
                                    </li>
                                }
                                {props.content.linkedin &&
                                    <li>
                                        <a href={props.content.linkedin} target="_blank" rel="noreferrer" className="text-darkgrey hover:text-red duration-300">
                                            <span className="sr-only">LinkedIn</span>
                                            <svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                                                <path
                                                fillRule="evenodd"
                                                d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z"
                                                clipRule="evenodd"
                                                />
                                            </svg>
                                        </a>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                    </div>
                </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    )
    
};


export default WithLargeImagesPopup